import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

const STYLES = {
  xsmall: { height: 16, borderRadius: 4 },
  small: { height: 30, borderRadius: 4 },
  mediumSmall: { height: 34, borderRadius: 4 },
  normal: { height: 40, borderRadius: 4 },
  large: { height: 50, borderRadius: 4 },
}

const Input = React.forwardRef(
  ({ className, group, size, disabled, style = {}, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="text"
        disabled={disabled}
        className={classNames(
          [
            'padding-vertical-normal',
            'border-solid border-shade-40 border-shade-30-on-focus',
            'shade-05 placeholder-shade-20',
          ],
          {
            // font-size
            'font-size-normal': size !== 'small',
            'font-size-small': size === 'small',
            // padding
            'padding-horizontal-medium': size !== 'small',
            'padding-horizontal-normal': size === 'small',
            // borders
            'border-small': !group,
            'border-top-small border-left-small border-bottom-small': group,
            'border-right-normal-transparent border-right-small-on-hover': [
              'left',
              'middle',
            ].includes(group),
            'border-right-small border-left-transparent-on-sibling-hovered':
              group === 'right',
            // radius
            'radius-normal': !group,
            'radius-left-normal': group === 'left',
            'radius-right-normal': group === 'right',
            // disabled
            'cursor-forbidden': disabled,
          },
          disabled ? 'background-stripped-shade-100' : 'background-transparent',
          className
        )}
        style={{ ...style, ...STYLES[size] }}
        {...props}
      />
    )
  }
)

Input.propTypes = {
  size: PropTypes.oneOf(['xsmall', 'small', 'mediumSmall', 'normal', 'large'])
    .isRequired,
  group: PropTypes.oneOf(['left', 'middle', 'right']),
}

Input.defaultProps = {
  size: 'normal',
}

export default Input
